import React, { useContext, useEffect, useState } from 'react'
import contactStyle from "../../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import styles from "../../../../../../assets/styles/componentStyles/accountInformationCard.module.scss";
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import { Autocomplete, Grid, TextField, Typography } from '@mui/material';
import GlobalButton from '../../../../../utility/globalButton/button';
import { convertDurationToMiliSeconds, convertMiliSecondsToDuration } from '../../../../../../utils/constants';
import { UserContext, UserContextPayload } from '../../../../../../context/userContext';
import { useGenericStore } from '../../../../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';
import ConfigurationSection from '../../../../chatbot/configurationPopup/ConfigurationSection';

interface AgentInactivityTimeProps {
    timeOfInactivityInMs: number,
    setTimeOfInactivityInMs: React.Dispatch<React.SetStateAction<number>>,
    configureAgentActivityMsg: (flagSendAgentActicityMsg: boolean, flagDisableAgentOnUserInactivity: boolean) => Promise<any>,
    flagSendAgentActicityMsg: boolean,
    onCancel: () => void,
    setShowPhoneNumberSettingsPopup: React.Dispatch<React.SetStateAction<boolean>>,
}

const AgentInactivityTime: React.FC<AgentInactivityTimeProps> = (props) => {
    
    const { timeOfInactivityInMs, setTimeOfInactivityInMs, configureAgentActivityMsg, flagSendAgentActicityMsg, onCancel, setShowPhoneNumberSettingsPopup } = props;

    const { handleError } = useContext(UserContext) as UserContextPayload;

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [duration, setDuration] = useState({
        days: 0,
        hours: 0,
        minutes: 0
    })

    useEffect(() => {
        const { days, hours, minutes } = convertMiliSecondsToDuration(timeOfInactivityInMs);
        setDuration({
            days: days,
            hours: hours,
            minutes: minutes
        })
    }, []);

    const generateAutoCompleteOptions = (length: number) => {
        return Array.from({ length: length }, (_, i) => ({
            label: `${i}`,
            value: i,
        }));
    } 

    const dayOptions = generateAutoCompleteOptions(7);
    const hourOptions = generateAutoCompleteOptions(24);
    const minuteOptions = generateAutoCompleteOptions(60);

    const onChangeOfDuration = (days: number, hours: number, minutes: number) => {
        setDuration({
            days: days,
            hours: hours,
            minutes: minutes
        })
        setTimeOfInactivityInMs(convertDurationToMiliSeconds(days, hours, minutes));
    }

    const onClickOfSave = async () => {
        const res = await configureAgentActivityMsg(flagSendAgentActicityMsg, true);
        if(res?.status){
            showSuccess("User inactivity time configured successfully")
            setShowPhoneNumberSettingsPopup(false);
        } else {
            handleError(res);
        }
    }

    return (
        <Grid container className={`${globalStyles.flexColumn} ${globalStyles.justifyCenter}`} gap={2}>
            
            <Grid item className={globalStyles.fullwidth} xs={12}>
                <ConfigurationSection
                    title="User Inactivity Time"
                    isSectionRequired
                >
                    <Grid container gap={1} className={`${globalStyles.displayFlex} ${styles.userInactivityTimeRow}`} alignItems="center">
                        <Autocomplete
                            className={`${contactStyle.contactFilterDropdownsInPopup} ${styles.userInactivityTimeAutocomplete}`}
                            disableClearable
                            options={dayOptions}
                            getOptionLabel={(option) => option?.label || ''}
                            value={dayOptions.find((opt) => opt.value === duration.days)}
                            onChange={(_, value) => onChangeOfDuration(value?.value ?? 0, duration.hours, duration.minutes)}
                            ListboxProps={{ className: styles.agentActivityMsgAutocompleteListbox }}
                            renderInput={(params) => <TextField {...params} placeholder="Days" />}
                        />
                        <Typography className={`${globalStyles.secondaryFontSize} ${globalStyles.secondaryFontWeight} ${styles.userInactivityTimeLabel}`}>
                            Days
                        </Typography>

                        <Autocomplete
                            className={`${contactStyle.contactFilterDropdownsInPopup} ${styles.userInactivityTimeAutocomplete}`}
                            disableClearable
                            options={hourOptions}
                            getOptionLabel={(option) => option?.label || ''}
                            value={hourOptions.find((opt) => opt.value === duration.hours)}
                            onChange={(_, value) => onChangeOfDuration(duration.days, value?.value ?? 0, duration.minutes)}
                            ListboxProps={{ className: styles.agentActivityMsgAutocompleteListbox }}
                            renderInput={(params) => <TextField {...params} placeholder="Hours" />}
                        />
                        <Typography className={`${globalStyles.secondaryFontSize} ${globalStyles.secondaryFontWeight} ${styles.userInactivityTimeLabel}`}>
                            Hours
                        </Typography>
                        
                        <Autocomplete
                            className={`${contactStyle.contactFilterDropdownsInPopup} ${styles.userInactivityTimeAutocomplete}`}
                            disableClearable
                            options={minuteOptions}
                            getOptionLabel={(option) => option?.label || ''}
                            value={minuteOptions.find((opt) => opt.value === duration.minutes)}
                            onChange={(_, value) => onChangeOfDuration(duration.days, duration.hours, value?.value ?? 0)}
                            ListboxProps={{ className: styles.agentActivityMsgAutocompleteListbox }}
                            renderInput={(params) => <TextField {...params} placeholder="Minutes" />}
                        />
                        <Typography className={`${globalStyles.secondaryFontSize} ${globalStyles.secondaryFontWeight} ${styles.userInactivityTimeLabel}`}>
                            Minutes
                        </Typography>
                    </Grid>
                </ConfigurationSection>
            </Grid>

            <Grid item className={`${globalStyles.fullwidth} ${styles.agentActivityMsgFooter}`}>
                <Grid container justifyContent="center" gap={2}>
                    <GlobalButton
                        className="borderedButtonStyle"
                        buttonText="Cancel"
                        sx={{ width: "120px", flexShrink: 0 }}
                        onClick={onCancel}
                    />

                    <GlobalButton
                        className="primaryButtonStyle"
                        buttonText="Save"
                        sx={{ width: "120px", flexShrink: 0 }}
                        disabled={timeOfInactivityInMs === 0}
                        onClick={() => onClickOfSave()}
                    />
                </Grid>
            </Grid>

        </Grid>
    )
}

export default AgentInactivityTime
